module.exports = __webpack_public_path__ + "img/43a-config-cadastros-restritos-form.617c83bd.png";